<cfp-login-card [title]="'login.forgot' | translate">
  <cfp-login-loading-spinner [loading]="loading" />
  <cfp-login-messages
    [errorMessages]="errorMessages"
    [warningMessages]="warningMessages"
    [successMessages]="successMessages"
  />

  @if (!formSubmitSuccess) {
    <form [formGroup]="form" data-test="forgotPasswordForm">
      <div class="form-group">
        <label for="username">{{ 'login.userNameOrEmail' | translate }}</label>
        <cfp-input-text
          [dataTest]="'userName'"
          [placeholder]="'login.userNameOrEmail.placeholder' | translate"
          formControlName="username"
          autocomplete="email"
        />
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <cfp-link class="px-0" [routerLink]="environment.loginRoute">{{ 'login.cancel' | translate }}</cfp-link>
          <cfp-button id="btn-login" (clicked)="submitForm()" [dataTest]="'forgotPasswordButton'">
            {{ 'login.submit' | translate }}
          </cfp-button>
        </div>
      </div>
    </form>
  }
  @if (formSubmitSuccess) {
    <cfp-link class="pull-left" [routerLink]="environment.loginRoute" [dataTest]="'forgotPasswordSuccessButton'">
      <cfp-icon [icon]="'arrow-left'" />
      {{ 'back.button' | translate }}
    </cfp-link>
  }
</cfp-login-card>
